/**
 * Thin status bar shown while the learner MFE has no network, or while queued
 * writes are flushing after reconnect.
 */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { isOnline, subscribeNetwork } from "./network";
import { subscribeSync } from "./sync";

/**
 * Fixed banner: cached content may be shown while disconnected.
 *
 * @returns {JSX.Element|null}
 */
const OfflineBanner = () => {
  const { t } = useTranslation("common");
  const [online, setOnline] = useState(isOnline());
  const [syncState, setSyncState] = useState({ pending: 0, syncing: false });

  useEffect(() => subscribeNetwork(setOnline), []);
  useEffect(() => subscribeSync(setSyncState), []);

  if (!online) {
    return (
      <div className="sticky top-0 z-[1200] bg-yellow-400 text-black text-center text-sm py-1 px-3">
        {t("You are offline. Showing saved course content.")}
      </div>
    );
  }

  if (syncState.syncing || syncState.pending > 0) {
    return (
      <div className="sticky top-0 z-[1200] bg-sky-200 text-black text-center text-sm py-1 px-3">
        {t("Back online. Sending saved chats, uploads, and API calls...")}
      </div>
    );
  }

  return null;
};

export default OfflineBanner;
